import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './home/header/header.component';
import { LoginComponent,MenuComponent,PrinterSetupComponent, QuickNavigationPanelComponent, QuickNavigationService, UserPreferenceService as CommonUserPreferenceService } from 'sce-home';
import { FooterComponent } from './home/footer/footer.component';
import { BreadcrumbComponent } from './home/breadcrumb/breadcrumb.component';
import { ProfileComponent } from './home/profile/profile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { TranslateResourcePipe } from '../shared/pipes/translate-resource.pipe';
import { HomeService } from './home/home.service';
import { LeftPanelContentsComponent } from './home/left-panel-contents/left-panel-contents.component';
import { LeftPanelService } from './home/services/left-panel.service';
import { UserPreferenceService } from './home/services/user-preference.service';
import { DialogModule, TooltipModule } from 'primeng/primeng';
import { SCEModalComponent, SCEUILibraryModule } from 'sce-ui-lib';
import { ReportsModule } from '../features/reports/reports.module';
import { SCECoreModule } from 'sce-core';
import { FeedbackComponent } from './home/feedback/feedback.component';
import { BottomPanelComponent } from './home/bottom-panel/bottom-panel.component';
import { BottomPanelService } from './home/bottom-panel/bottom-panel.service';
import { FavoritesComponent } from './home/favorites/favorites.component';
import { MatAutocompleteModule, MatFormFieldModule, MatInputModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    SharedModule,
    ReportsModule,
    TooltipModule,
    SCECoreModule,
    SCEUILibraryModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule
  ],
  declarations: [
    TranslateResourcePipe,
    BottomPanelComponent,
    FavoritesComponent,
    HomeComponent,
    HeaderComponent,
    LoginComponent,
    FeedbackComponent,
    FooterComponent,
    MenuComponent,
    BreadcrumbComponent,
    ProfileComponent,
    LeftPanelContentsComponent,
    PrinterSetupComponent,
    QuickNavigationPanelComponent
    
  ],
  providers: [
    BottomPanelService,
    HomeService,
    UserPreferenceService,
    LeftPanelService,
    QuickNavigationService,
    CommonUserPreferenceService
  ],
  entryComponents: [
    SCEModalComponent,
    PrinterSetupComponent,
    FeedbackComponent,
    BottomPanelComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LayoutModule { }


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/layout/layout.module.ts